"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Select;

var _style = require("./style");

var _jsxRuntime = require("react/jsx-runtime");

function Select(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Container, {
    width: props.width,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.SelectCustom, {
      id: props.id,
      width: props.width,
      onChange: props.onChange,
      value: props.valueSelected ? props.valueSelected : "",
      className: props.className,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: "",
        disabled: true,
        children: props.placeholder
      }), props.options && props.options.map(function (item, i) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
          className: item.required ? "option-required" : "" //className={ ? "option-required" : ""}
          ,
          value: item.value ? item.value : item // selected={
          //   item.value
          //     ? item.value === props.valueSelected && "selected"
          //     : item === props.valueSelected && "selected"
          // }
          ,
          children: [item.name ? item.name : item, " ", item !== null && item !== void 0 && item.required ? "*" : ""]
        }, "select-" + item.value ? item.value : item + "-" + i);
      })]
    })
  });
}